export default class Select {
  static byId<T extends HTMLElement>(id: string): T {
    return document.getElementById(id) as T;
  }

  static byClass<T extends HTMLElement>(className: string): T {
    return document.getElementsByClassName(className)[0] as T;
  }

  static byClassAll<T extends HTMLElement>(className: string): T[] {
    return Array.from(document.getElementsByClassName(className)) as T[];
  }

  static byCss<T extends HTMLElement>(selector: string): T {
    return document.querySelector(selector) as T;
  }

  static byCssAll<T extends HTMLElement>(selector: string): T[] {
    return Array.from(document.querySelectorAll(selector)) as T[];
  }
}
